var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanva({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1816 14.147C15.183 14.5652 15.1017 14.9796 14.9423 15.3662C14.7829 15.7529 14.5486 16.1042 14.2529 16.3999C13.9571 16.6956 13.6059 16.9299 13.2192 17.0893C12.8326 17.2487 12.4182 17.33 12 17.3286C11.5818 17.33 11.1674 17.2487 10.7808 17.0893C10.3941 16.9299 10.0428 16.6956 9.74713 16.3999C9.45141 16.1042 9.2171 15.7529 9.05771 15.3662C8.89831 14.9796 8.81698 14.5652 8.81838 14.147V9.853C8.81698 9.43479 8.89831 9.02043 9.05771 8.63379C9.2171 8.24714 9.45141 7.89585 9.74713 7.60013C10.0428 7.30441 10.3941 7.0701 10.7808 6.91071C11.1674 6.75131 11.5818 6.66997 12 6.67137C12.4123 6.67181 12.8203 6.75529 13.1996 6.91682C13.5789 7.07835 13.9218 7.31462 14.2079 7.61155C14.4939 7.90848 14.7172 8.25997 14.8645 8.64507C15.0117 9.03017 15.0799 9.44098 15.065 9.853M22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/canva.addd1e713058237e1ec6cffc2b59d29f.svg";
export { ForwardRef as ReactComponent };